import React from "react";
const AppHeading2=({children})=>{
    return(
        <h2 className="font-semibold text-14px leading-22px tracking-0.01em capitalize">{children}</h2>
    )
}

export default AppHeading2

